import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteSpeakerPayload } from '@app-store/slices/speakers/deleteSpeaker'

interface TaskAction extends Action {
    payload: IDeleteSpeakerPayload
}

const { onRequest, onSuccess, onFailure } = rootActions.speakers.delete

function* deleteSpeakerSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/event/speaker/${payload.SpeakerId}`)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Speaker deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess(response.result)
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteSpeakerSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteSpeakerSagaTask)
}

export default deleteSpeakerSaga
